// @givmo/employer-module — WHO MAY CHANGE THE COMPANY VISIBILITY SETTINGS (EP-SUITE7, D-EP-50 (3);
// EP-WEB30's rider).
//
// The three Company visibility writers — company-profile visibility, activity-feed visibility and the
// dollar amounts (EP-MNT16) — all carry `company:edit_visibility` on the server
// (`company_service.py`), split out of `company:edit` by EP-SUITE7: every Global Admin holds it, every
// Donations Owner by default, and a Global Admin can take it away (or hand it to a Member) with
// Customize. So that ONE string decides who sees the settings as controls, on both hosts:
//
//   - the console's Company visibility card is mounted only for a holder, and a contextual link to it
//     is gated the same way (`holdsPrivacySettings`, fail CLOSED: an unknown set shows no link);
//   - the portal's Privacy tab shows a holder the controls and anyone else a read-only account of
//     the current settings (`mayEditVisibility`) — never radios the server refuses (a decorative
//     control: a Member's change answered 403 and rolled back, cut 18's review F3). It follows the
//     funding acts' rule (`funding-permissions.ts`): the base-role Owner, or the act's own string in
//     the standing read; and while that read has FAILED it fails OPEN, since the server checks every
//     write and a transient failure must never strand a real Owner.
//
// A separate module so the card (which renders the tab's sections) and the tab can both read it
// without importing each other.

import { ROLE_OWNER } from '../admins/admins-roles';
import type { FundingStanding } from './funding-permissions';

/** The ONE string all three writers' decorators name — the card's gate, its links' and the tab's. */
export const PRIVACY_SETTINGS_PERMISSION = 'company:edit_visibility';

/**
 * Whether a standing read's effective set holds the settings' write string — the gate a contextual
 * link shares with the card. Fails CLOSED: an unknown set (still loading, failed, or a read that
 * carries no list) shows no link, since the page it opens would not draw the card on a guess either.
 */
export function holdsPrivacySettings(permissions: readonly string[] | null | undefined): boolean {
  return Array.isArray(permissions) && permissions.includes(PRIVACY_SETTINGS_PERMISSION);
}

/**
 * Whether the portal's Privacy tab shows this person the controls. The base-role Owner, or a holder
 * of the string; an UNSETTLED read (failed) answers yes — the server's 403 is the backstop. A host
 * shows no controls while the read is still pending (the tab draws a placeholder), so "unsettled"
 * here means "failed".
 */
export function mayEditVisibility(standing: FundingStanding): boolean {
  if (!standing.settled) return true;
  if (standing.role === ROLE_OWNER) return true;
  return holdsPrivacySettings(standing.permissions);
}
